<template>
  <div class="bg-container">
    <v-container fluid fill-height v-bind:style="{ maxWidth: '1200px' }">
      <v-layout flex align-center>
        <v-flex xs12 sm6 md6 offset-sm3 offset-md3>
          <v-card class="no-shadow no-background">
            <v-card-title primary-title>
              <h1 class="headline">Reset password</h1>
            </v-card-title>
            <v-card-text>
              <p class="head-description">
                Enter your email address and we will send you a link to reset your
                password
              </p>
            </v-card-text>
            <v-card-text>
              <v-form @submit.prevent="send" @keydown="form.onKeydown($event)">
                <p
                  v-if="
                    status ==
                      'Unable to send password reset link! You\'re sure this is the correct e-mail address?'
                  "
                  class="invalid-feedback"
                >
                  {{ status }}
                </p>
                <p v-else class="status-success">{{ status }}</p>

                <!-- Email -->
                <v-text-field
                  label="E-Mail"
                  placeholder="E-Mail"
                  v-model="form.email"
                  single-line
                  required
                  autofocus
                  class="placeholer-color"
                  :error="form.errors.has('email')"
                ></v-text-field>
                <has-error :form="form" field="email"></has-error>

                <v-layout>
                  <v-flex class="text-xs-left">
                    <v-btn type="submit" :loading="form.busy" color="primary" class="mt-4" right>{{ $t('Confirm') }}</v-btn>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Form from "vform"

export default {
  metaInfo() {
    return { title: this.$t("reset_password") }
  },

  data: () => ({
    status: "",
    form: new Form({
      email: ""
    })
  }),

  methods: {
    async send() {
      try {
        const { data } = await this.form.post("/api/v1/password/email")

        this.status = data.status
      } catch (error) {
        this.status = error.response.data.status
      } finally {
        this.form.reset()
      }
    }
  }
}
</script>

<style scoped>
.bg-container {
  background: url("/img/background-center.png") center top no-repeat,
  url("/img/background-full.jpg") repeat;
  height: 100%;
}
.no-shadow {
  box-shadow: none !important;
}
.no-background {
  background: transparent;
}
.placeholer-color >>> input::placeholder {
  color: #b8d2ff !important;
  opacity: 1;
}
>>> .v-input__slot::before {
  border-color: #b8d2ff !important;
}

>>> .v-btn {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff !important;
  background: linear-gradient(180deg, #468aff 0%, #0051dd 100%);
  border-radius: 30px;
  width: 196px;
  height: 44px;
  box-shadow: none !important;
}
.headline {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 40px !important;
  line-height: 48px !important;
  letter-spacing: 0.02em !important;
  background: -webkit-linear-gradient(#468aff, #0051dd);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.head-description {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: #103a84;
  margin-bottom: 0px;
}
.v-messages__message {
  color: #ed4242;
}
.invalid-feedback {
  color: #ed4242;
}
.status-success {
  color: #208b62ff;
}
@media (max-width: 1440px) {
  .bg-container {
    background: url("/img/background-center.png") center top no-repeat,
    url("/img/background-full-1440.jpg") repeat;
    height: 100%;
  }
}
@media (max-width: 768px) {
  .bg-container {
    background: #ffffff url("/img/bg-tablet-left.jpg") left top no-repeat;
    height: 100%;
  }
}
@media (max-width: 600px) {
  .bg-container {
    background: #ffffff;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/pages/auth/password/email.vue